import styled, { css } from 'styled-components';

import { resetBrowserButton } from '../../Button/styles';
import { resetBrowserAnchor } from '../../Anchor/styles';

import styles from '../../Dropdown/components/DropdownItem/styles';
import DropdownBox from '../../Dropdown/components/DropdownBox/DropdownBox';

import { horizontalNavTokens } from '../../../tokens/components/HorizontalNav/tokens';
import { subNavTokens } from '../../../tokens/components/SubNav/tokens';

const horizontalNavItems = {
  ghost: css`
    color: ${horizontalNavTokens.CoreFontColorSelected};
    font-weight: ${horizontalNavTokens.CoreFontWeightInitial};
    margin-right: ${horizontalNavTokens.CoreGapHorizontal};
    padding: ${horizontalNavTokens.CoreSpacingVertical} ${horizontalNavTokens.CoreSpacingHorizontal};

    &:hover,
    &:focus-visible {
      box-shadow: inset 0 -${horizontalNavTokens.CoreBorderSize} 0 0 ${horizontalNavTokens.CoreColorBorderHover};
      color: ${horizontalNavTokens.CoreFontColorHover};
    }

    &:focus-visible {
      outline: ${horizontalNavTokens.CoreOutlineStroke} ${horizontalNavTokens.CoreOutlineColor};
      outline-offset: ${horizontalNavTokens.CoreOutlineOffset};
    }

    &:active {
      box-shadow: inset 0 -${horizontalNavTokens.CoreBorderSize} ${horizontalNavTokens.CoreColorBorderActive};
      color: ${horizontalNavTokens.CoreFontColorActive};
    }
  `,
  activeTrigger: css`
    box-shadow: inset 0 -${horizontalNavTokens.CoreBorderSize} 0 0 ${horizontalNavTokens.CoreColorBorderHover};
    color: ${horizontalNavTokens.CoreFontColorHover};
  `,
  selected: css`
    box-shadow: inset 0 -${horizontalNavTokens.CoreBorderSize} ${horizontalNavTokens.CoreColorBorderSelected};
    font-weight: ${horizontalNavTokens.CoreFontWeightSelected};
    color: ${horizontalNavTokens.CoreFontColorSelected};
  `,
};

const subNavItems = {
  ghost: css`
    border-radius: ${subNavTokens.CoreBorderRadius};
    color: ${subNavTokens.CoreFontColorInitial};
    font-weight: ${subNavTokens.CoreFontWeight};
    margin-right: ${subNavTokens.CoreGapHorizontal};
    padding: ${subNavTokens.CoreSpacingVertical} ${subNavTokens.CoreSpacingHorizontal};

    &:hover,
    &:focus-visible {
      background: ${subNavTokens.CoreBackgroundColorHover};
    }

    &:focus-visible {
      outline: ${subNavTokens.CoreOutlineStroke} ${subNavTokens.CoreOutlineColor};
      outline-offset: ${subNavTokens.CoreOutlineOffset};
    }

    &:active {
      background: ${subNavTokens.CoreBackgroundColorPressed};
    }
  `,
  activeTrigger: css`
    // pressed state
    background: ${subNavTokens.CoreBackgroundColorPressed};
  `,
  selected: css`
    color: ${subNavTokens.CoreFontColorSelected};
    background: ${subNavTokens.CoreBackgroundColorSelected};
  `,
};

const NavItemElement = styled.div`
  ${resetBrowserButton}
  ${resetBrowserAnchor}
  display: inline-flex;
  align-items: center;
  transition: all 100ms ease;

  &:hover {
    cursor: pointer;
  }

  ${({ theme }) =>
    theme.isHorizontalNav &&
    css`
      ${horizontalNavItems.ghost}

      ${theme.dropdownActive &&
      css`
        ${horizontalNavItems.activeTrigger}
      `};

      ${theme.active &&
      css`
        ${horizontalNavItems.selected}
      `};
    `}

  ${({ theme }) =>
    theme.isSubNav &&
    css`
      ${subNavItems.ghost}

      ${theme.dropdownActive &&
      css`
        ${subNavItems.activeTrigger}
      `};

      ${theme.active &&
      css`
        ${subNavItems.selected}
      `};
    `};

  ${DropdownBox} && {
    ${styles}
  }
`;

export default NavItemElement;
